import { PublicClientApplication } from '@azure/msal-browser';
import {
  getEntraLoginRequest,
  getEntraMfaStepUpRequest,
  getMsalConfig,
  isEntraConfigured,
} from './entraConfig';

let instance = null;
let initPromise = null;

export function getMsalInstance() {
  if (!isEntraConfigured()) {
    return null;
  }
  if (!instance) {
    instance = new PublicClientApplication(getMsalConfig());
    initPromise = instance.initialize();
  }
  return instance;
}

export async function ensureMsal() {
  const msal = getMsalInstance();
  if (!msal) {
    return null;
  }
  await initPromise;
  return msal;
}

export async function beginEntraSignIn() {
  const msal = await ensureMsal();
  if (!msal) {
    throw new Error('Microsoft Entra is not configured');
  }
  await msal.loginRedirect(getEntraLoginRequest());
}

export async function completeEntraRedirect() {
  const msal = await ensureMsal();
  if (!msal) {
    return null;
  }
  const result = await msal.handleRedirectPromise();
  if (result?.account) {
    msal.setActiveAccount(result.account);
  }
  const account = msal.getActiveAccount() || msal.getAllAccounts()[0] || null;
  if (!account) {
    return result
      ? { accessToken: result.accessToken || '', account: result.account || null }
      : null;
  }
  if (result?.accessToken) {
    return { accessToken: result.accessToken, account };
  }
  const silent = await msal.acquireTokenSilent({
    ...getEntraLoginRequest(),
    account,
  });
  return { accessToken: silent.accessToken, account };
}

export async function logoutEntra() {
  const msal = await ensureMsal();
  if (!msal) {
    return false;
  }
  const account = msal.getActiveAccount() || msal.getAllAccounts()[0];
  if (!account) {
    return false;
  }
  await msal.logoutRedirect({ account });
  return true;
}

export async function acquireEntraMfaToken() {
  const msal = await ensureMsal();
  if (!msal) {
    throw new Error('Microsoft Entra is not configured');
  }
  const account = msal.getActiveAccount() || msal.getAllAccounts()[0];
  if (!account) {
    throw new Error('Sign in with Microsoft before confirming multi-factor authentication.');
  }
  const result = await msal.acquireTokenPopup({
    ...getEntraMfaStepUpRequest(),
    account,
  });
  if (!result?.accessToken) {
    throw new Error('Microsoft did not return an MFA confirmation.');
  }
  return result.accessToken;
}
